// extracted by mini-css-extract-plugin
export var heroContainer = "notfound-module--heroContainer--z0K8B";